export default function($) {
  var speed = 90; // ms
  $('.menu-item-has-children a').attr('aria-haspopup', "true").attr('aria-expanded', 'false');

  $('.menu-item-has-children').click(function (event) {
    event.stopPropagation();
    var isActive = $(this).hasClass('menu-item-has-children--active');
    $(this).siblings('.menu-item-has-children--active').each(function(i, sibling) {
      $(sibling).removeClass('menu-item-has-children--active').children('.sub-menu').slideUp(speed);
      $(sibling).find('a').attr('aria-expanded', 'false');
    });
    $(this).children('.sub-menu').slideToggle(speed);
    $(this).toggleClass('menu-item-has-children--active');

    $(this).find('a').attr('aria-expanded', isActive ? 'false' : 'true');
  });

  $(document).click(function(event) {
    if (!$(event.target).closest('.js-nav').length) {
      if ($('.sub-menu').is(":visible")) {
        $('.sub-menu').slideUp(speed);
        $('.menu-item-has-children--active').removeClass('menu-item-has-children--active');
        $('.menu-item-has-children a').attr('aria-expanded', 'false');
      }
    }
  });

  $(window).scroll(function() {
    if ($(this).scrollTop() >= 100) {
      $('.js-backtotop').fadeIn();
    } else {
      $('.js-backtotop').fadeOut();
    }
  });
}
